import React from 'react';
import { ChatScreen } from '../shared/ChatScreen';

interface CoordinatorChatScreenProps {
  onBack?: () => void;
}

export const CoordinatorChatScreen = ({ onBack }: CoordinatorChatScreenProps = {}) => {
  return <ChatScreen userRole="COORDINATOR" onBack={onBack}  chatUser={null}/>;
};
